module.exports = __webpack_public_path__ + "img/l2.8f55d59d.png";